import { render, staticRenderFns } from "./GlossaryPage.vue?vue&type=template&id=333ac55f"
import script from "./GlossaryPage.vue?vue&type=script&lang=js"
export * from "./GlossaryPage.vue?vue&type=script&lang=js"
import style0 from "./GlossaryPage.vue?vue&type=style&index=0&id=333ac55f&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports